import { Typography } from 'antd';
import styled from '@emotion/styled';

export const Title = styled(Typography.Title)`
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-align: left;
`;
